import { IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Fragment, useState } from 'react';
import PreviewAnexos from '../../../../../utils/PreviewAnexos';
// import InputDocUpload from '../../../../../utils/inputFileUpload/inputDocUpload';


export default function AddImagens({ avaliacao, setAvaliacao, addImagens }) {

    const [previewFiles, setPreviewFiles] = useState([]);
    const [currentFileIndex, setCurrentFileIndex] = useState(0);
    const [previewOpen, setPreviewOpen] = useState(false);

    const handleOpenPreview = (documents, fileIndex = 0) => {
        const valid = documents.filter((d) => typeof d === "string" && d.trim() !== "");
        if (!valid.length) return;
        setPreviewFiles(valid);
        setCurrentFileIndex(fileIndex);
        setPreviewOpen(true);
    };

    const handleClosePreview = () => setPreviewOpen(false);

    const handleNavigate = (index) => {
        if (index >= 0 && index < previewFiles.length) {
            setCurrentFileIndex(index);
        }
    };


    async function HandleChangeFile(file, name) {
        if (!file) return;

        // Garante que file é convertido em array
        const arquivos = Array.from(file);

        setAvaliacao(prev => ({
            ...prev,
            imagens: [...(prev.imagens || []), ...arquivos]
        }));
    }

    // REMOVER IMAGENS SELECIONADAS
    function removerImagemPorIndice(indice) {
        setAvaliacao(prev => ({
            ...prev,
            imagens: prev.imagens.filter((_, i) => i !== indice)
        }));
    }

    return (
        <>
            {avaliacao?.imagens?.length > 0 &&
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {avaliacao?.imagens.map((imagem, index) =>
                        <Fragment key={index}  >
                            {addImagens &&
                                <IconButton style={{ height: 10 }} onClick={() => removerImagemPorIndice(index)}> <CloseIcon color='error' /></IconButton>
                            }
                            <img src={addImagens ? URL.createObjectURL(imagem) : imagem} alt={index} width={'25%'} style={{ margin: 5 }} onClick={() => handleOpenPreview(avaliacao?.imagens, 0)} />
                        </Fragment>
                    )}

                    <PreviewAnexos
                        files={previewFiles}
                        currentIndex={currentFileIndex}
                        isOpen={previewOpen}
                        onClose={handleClosePreview}
                        onNavigate={handleNavigate}
                    />
                </div>
            }

            {addImagens &&
                <div align="center" style={{ borderRadius: 5, marginTop: 10, border: '2px dashed #d1d5db', height: '4rem' }}>
                    <label htmlFor="imagens" style={{ margin: 5, cursor: 'pointer' }} >
                        <Typography variant="subtitle2" >
                            Adicionar imagens (opcional)
                        </Typography>
                    </label>
                    <input disabled={!avaliacao} multiple accept=" image/png, image/jpg, image/jpeg" type="file" name="imagens" id="imagens" style={{ display: 'none' }} onChange={(e) => HandleChangeFile(e.target.files, 'name')} />
                </div>
            }


            {/* USANDO O input PARA FACILITAR O USO DO InputDocUpload */}
            {/* <input disabled={!avaliacao} multiple accept=" image/png, image/jpg, image/jpeg" type="file" name="imagens" id="imagens" style={{ display: 'none' }} onChange={(e) => HandleChangeFile(e.target.files, 'name')} />
            {addImagens &&
                <InputDocUpload
                    fullWidth={true}
                    imputLigth={true}
                    onFileSelect={HandleChangeFile}
                    inputName="imagens"
                    inputTitle="Clica para adicionar imagens (opcional)"
                    inputDescription="Adicionar imagens (opcional)"
                />
            } */}
        </>
    )
}
